// extracted by mini-css-extract-plugin
module.exports = {"LearningTile":"LearningTile_LearningTile__CBcrR","NavImage":"LearningTile_NavImage__1UL_E","Button":"LearningTile_Button__1rta9","Headline":"LearningTile_Headline__1SpNc"};